import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpDeleteView, HttpDeleteViewOptions} from '../http/views.http'
import {QUERY_KEYS} from '@/queryClient'

export const useDeleteView = (
    options?: Omit<UseMutationOptions<void, unknown, HttpDeleteViewOptions>, 'mutationFn'>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data => httpDeleteView(data),
        ...options,
        onSuccess: (data, variables, context) => {
            options?.onSuccess?.(data, variables, context)
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.VIEWS]})
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.VIEW, variables.urlParams.id]})
        }
    })
}
